const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M70.1,155.75a8.35,8.35,0,0,1,8.35-8.36H203.77a8.36,8.36,0,1,1,0,16.71H78.46a8.36,8.36,0,0,1-8.36-8.34Zm267.35,53.47a8.37,8.37,0,0,0-8.35-8.36H78.46a8.36,8.36,0,1,0,0,16.71H329.09a8.35,8.35,0,0,0,8.36-8.34Zm-94.58,45.11H78.46a8.36,8.36,0,1,0,0,16.71H218A128.42,128.42,0,0,1,242.87,254.33ZM78.46,307.8a8.36,8.36,0,1,0,0,16.71H179.8a131.77,131.77,0,0,1,7.85-16.71Zm0,53.47a8.36,8.36,0,1,0,0,16.71h92.31c-.08-1.68-.08-3.35-.08-5,0-3.92.17-7.85.5-11.69Zm0,70.17H184.22a129,129,0,0,1-6.85-16.7H78.46a8.35,8.35,0,1,0,0,16.7Zm0,41.78a25.14,25.14,0,0,1-25.07-25.07V63.85A25.14,25.14,0,0,1,78.46,38.78H245.55a16.72,16.72,0,0,1,16.71,16.7h0V88.91A41.78,41.78,0,0,0,304,130.68h33.42a16.09,16.09,0,0,1,11.78,4.93,16.33,16.33,0,0,1,4.92,11.78V249a117.6,117.6,0,0,1,16.71,8.11V147.39a33.57,33.57,0,0,0-9.77-23.64l-91.9-91.9a33.64,33.64,0,0,0-23.64-9.78H78.46A41.8,41.8,0,0,0,36.68,63.85v384.3a41.8,41.8,0,0,0,41.78,41.78H239.7a133,133,0,0,1-23.64-16.71ZM402.61,352.58a109.83,109.83,0,0,1,2,20.38,100.34,100.34,0,1,1-52.39-88l12.2-12.2A115.73,115.73,0,0,0,304.36,256a117,117,0,1,0,117,117,114.78,114.78,0,0,0-5.09-34.08Zm70.26-105.69-23.64-23.64a8.32,8.32,0,0,0-11.77,0h0L295.34,365.36l-33.08-33a8.32,8.32,0,0,0-11.77,0h0l-23.65,23.56a8.41,8.41,0,0,0,0,11.86l62.58,62.58a8.28,8.28,0,0,0,5.93,2.42,8.08,8.08,0,0,0,5.85-2.42L472.87,258.67a8.3,8.3,0,0,0,0-11.76v0Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.28,55q7.64,0,12,4.77t4.41,12.36a17.67,17.67,0,0,1-4.41,12.32q-4.42,4.86-12.53,4.87T75.56,84.44a17.89,17.89,0,0,1-4.27-12.29,17.43,17.43,0,0,1,4.49-12.31Q80.26,55,88.28,55ZM88,62q-6.72,0-6.72,10A14.38,14.38,0,0,0,83,79.52a5.6,5.6,0,0,0,5.14,2.76q6.72,0,6.72-10.08Q94.81,62,88,62Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.07,88.66V55.59h24.72v7.2H119.58v6.43h14.25v7.2H119.58V88.66Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.64,88.66V55.59h24.72v7.2H149.14v6.43H163.4v7.2H149.14V88.66Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.59,68.12v7.15H178.52v6.19h16.85l-1.11,7.2h-25V55.59h25v7.2H178.52v5.33Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.65,76.18h-3.41V88.66h-9.41V55.59H216.2c3.74,0,6.61.87,8.59,2.59a8.36,8.36,0,0,1,3,6.58,8.15,8.15,0,0,1-1.47,5.06,8.06,8.06,0,0,1-3.48,2.76c2.85,1,4.27,3.84,4.27,8.55v1.39a30.16,30.16,0,0,0,.44,6.14h-9.22q-.67-1.81-.67-7.2V80.6a4.76,4.76,0,0,0-1-3.38C216,76.53,214.66,76.18,212.65,76.18Zm-3.41-13.82v7.06h4.51q4.37,0,4.37-3.56t-4.37-3.5Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.78,133.86V100.79H88.09a13.53,13.53,0,0,1,9,2.91,9.6,9.6,0,0,1,3.43,7.7c0,3.55-1.19,6.25-3.55,8.09a14.44,14.44,0,0,1-9.12,2.76H82.33v11.61Zm9.55-26.25v7.82h4c3.11,0,4.66-1.29,4.66-3.89s-1.55-3.93-4.66-3.93Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.22,100.79h9.7v20.35q0,3.31,1.44,4.83a5,5,0,0,0,3.84,1.51q5,0,5-6.34V100.79h9.7v19.35q0,14.34-14.88,14.35-7.07,0-11-3.34t-3.89-11Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.25,133.86h-8.88V100.79H153c.64,1.38,1.83,3.87,3.56,7.49s3.11,6.57,4.15,8.86,1.77,4,2.18,5.25h.19q-.48-4.32-.48-14.54v-7.06h8.84v33.07h-11q-.39-.86-3.27-6.93t-4.63-10c-1.17-2.59-2-4.55-2.47-5.86h-.1q.33,3.65.34,15.31Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54,123h9.64a13.31,13.31,0,0,1-4.85,8.45q-3.89,3.06-10.51,3.07-7.81,0-11.95-4.68t-4.13-12.22a21.51,21.51,0,0,1,1-6.69,16.92,16.92,0,0,1,3-5.52,13.32,13.32,0,0,1,5.21-3.82,18.44,18.44,0,0,1,7.36-1.39q6.78,0,10.49,3.31a12.57,12.57,0,0,1,4.3,8.06h-9.6q-.92-4.56-5.43-4.56-6.33,0-6.33,10.28t6.43,10.41Q197.44,127.67,198.54,123Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.79,133.86V100.79h9.75v12.39h10.08V100.79h9.74v33.07h-9.74V120.33H222.54v13.53Z",
    style: {
      fill: "#0096ff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature1.255932a0c53d7b8eeea8e0f627a30928.svg";
export { ForwardRef as ReactComponent };